import { Editor, Element } from 'slate';
// eslint-disable-next-line import/no-cycle
import { CustomElement } from 'src/types/CustomSlateTypes';

const isBlockActive = (
  editor: Editor,
  format: CustomElement['type'],
) => {
  const { selection } = editor;
  if (!selection) return false;

  const [match] = Array.from(
    Editor.nodes(editor, {
      at: Editor.unhangRange(editor, selection),
      match: (n) => !Editor.isEditor(n)
              && Element.isElement(n)
              && n.type === format,
    }),
  );

  return !!match;
};

export default isBlockActive;
